function initSlider(sectionSelector, listSelector, prevSelector, nextSelector, dotsSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);
  const dotsContainer = section.querySelector(dotsSelector);

  if (!list) return;

  const items = list.children;
  const totalSlides = items.length;
  let current = 0;

  // 1. Створюємо dots (якщо вони потрібні в розмітці)
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('span');
      dot.classList.add('slider-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        current = i;
        scrollToSlide();
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.slider-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === current);
    });
  }

  function scrollToSlide() {
    const item = list.querySelectorAll('.gallery-step, .natural-step');
    if (!item) return;

    const gap = parseInt(getComputedStyle(list).gap) || 0;
    const stepWidth = item[0].offsetWidth + gap;

    list.scrollTo({
      left: stepWidth * current,
      behavior: 'smooth'
    });

    updateDots();
  }

  const scroll = (direction) => {
    const max = totalSlides - 1;
    if (direction === 'next') {
      current = current < max ? current + 1 : current;
    } else {
      current = current > 0 ? current - 1 : 0;
    }
    scrollToSlide();
  };

  if (nextBtn) {
    nextBtn.addEventListener('click', () => scroll('next'));
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => scroll('prev'));
  }
}

// Виклик функції
initSlider(
  '.gallery-section',
  '.gallery-steps',
  '.btn-prev',
  '.btn-next'
);

initSlider(
  '.natural-section',
  '.natural-steps',
  '.btn-prev',
  '.btn-next'
);
